// Chip — INTERACTIVE pill button (filter toggle, multi-select option,
// removable selection). Clickable; reflects an active/inactive state.
//
// For passive uppercase labels (status flags, version markers), use
// <Tag> instead — different shape, different semantic.
//
// Design today is the StatsScreen "filter chip" form: rounded pill,
// bordered, swap to accent.main when active. Other interactive-pill
// shapes in the codebase (CompetitorsScreen.ScopePill — borderless,
// theme.tint inactive) deliberately stay local until we add a
// variant prop here. Single visual variant on purpose.

import type { AccentTokens, ThemeTokens } from '@nayto/theme';

interface ChipProps {
  label: string;
  active: boolean;
  onClick: () => void;
  theme: ThemeTokens;
  accent: AccentTokens;
}

export function Chip({ label, active, onClick, theme, accent }: ChipProps) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '6px 12px',
        borderRadius: 999,
        border: `1px solid ${active ? accent.main : theme.border}`,
        background: active ? accent.main : theme.surface,
        color: active ? '#fff' : theme.textMuted,
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
    >
      {label}
    </button>
  );
}
